import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import TooltipValidation from '../../../molecules/Validation/TooltipValidation';
import { validationDisplayTypePropType } from '../../../molecules/Validation/propTypes';
import Pill from '../../Pill';
import Input from '../../TextField/Input';
import { SimpleInput } from '../../TextField/SimpleTextField';
import textFieldComposer from '../../TextField/TextFieldComposer';
const SelectInput = ({ autoFocus, controlInputClassName, pills, multiSelect, onPillClear, asyncValidationInProgress, readOnlyInput, type, inputRef, inputControlClassName, inputProps, controlProps, isFocused, simple, sizeSmall, value, outline, tooltip, additionalInputElement, inputControlRef, ...other })=>{
    const pill = multiSelect && pills && pills.map(({ key, label, validationClassName, validationText, ...otherPillProps })=>{
        return /*#__PURE__*/ React.createElement(Pill, {
            onClick: onPillClear,
            className: "Input-pill",
            disabled: inputProps.disabled || inputProps.readOnly,
            pillId: key,
            key: key,
            ...otherPillProps
        }, label, validationText && /*#__PURE__*/ React.createElement("div", {
            className: "Input-pill--validation"
        }, /*#__PURE__*/ React.createElement(TooltipValidation, {
            validationClassName: validationClassName,
            validationText: validationText
        })));
    });
    const hasFloatingLabel = inputProps?.floatingLabelText;
    const showPlaceholder = !hasFloatingLabel || isFocused && controlProps.placeholder;
    const inputElement = /*#__PURE__*/ React.createElement("input", {
        autoFocus: autoFocus,
        ref: inputRef,
        ...other,
        ...controlProps,
        className: cx('Input-control', inputControlClassName, controlInputClassName, {
            'Input-control--showPlaceholder': showPlaceholder
        }),
        type: type,
        readOnly: readOnlyInput
    });
    const { className, ...otherInputProps } = inputProps;
    const InputType = simple ? SimpleInput : Input;
    return /*#__PURE__*/ React.createElement(InputType, {
        floatingLabelShrink: !!controlProps.value || !!controlProps.placeholder || isFocused || pill && pill.length > 0,
        className: cx({
            'Input--typeMultiselect': multiSelect
        }, className),
        asyncValidationInProgress: asyncValidationInProgress,
        value: value,
        outline: outline,
        sizeSmall: sizeSmall,
        tooltip: tooltip,
        ...otherInputProps
    }, pill ? pill : null, inputElement, additionalInputElement);
};
SelectInput.propTypes = {
    // for the sake of brevity, description of propTypes are in TextField.
    additionalInputElement: PropTypes.node,
    asyncValidationInProgress: PropTypes.bool,
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    controlClassName: PropTypes.string,
    controlInputClassName: PropTypes.string,
    controlProps: PropTypes.object,
    controlTextareaClassName: PropTypes.string,
    disabled: PropTypes.bool,
    floatingLabelClassName: PropTypes.string,
    floatingLabelText: PropTypes.node,
    hideValidationText: PropTypes.bool,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    inputRef: PropTypes.any,
    labelClassName: PropTypes.string,
    labelNote: PropTypes.node,
    labelPosition: PropTypes.any,
    labelText: PropTypes.node,
    multiSelect: PropTypes.bool,
    multiline: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onPillClear: PropTypes.func,
    outline: PropTypes.bool,
    panelControls: PropTypes.node,
    pills: PropTypes.array,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    readOnlyInput: PropTypes.bool,
    rows: PropTypes.number,
    simple: PropTypes.bool,
    sizeSmall: PropTypes.bool,
    tooltip: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    type: PropTypes.string,
    validationClassName: PropTypes.string,
    validationDisplayType: validationDisplayTypePropType,
    validationText: PropTypes.node,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ])
};
export { SelectInput };
export default textFieldComposer(SelectInput, false);
